export function getChecklistRowsSchema() {
  return [
    {
      name: "id",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [],
      similair: [],
      helperText: "",
      nullable: false,
      readOnly: true,
      error: false,
    },
    {
      name: "Row Text",
      default: "",
      type: "string",
      maxLength: 20,
      selectables: [],
      similair: [
        "text",
        "row",
        "desc",
        "description",
        "value",
        "line",
        "line text",
      ],
      nullable: false,
      readOnly: false,
      helperText: "",
      error: false,
    },
    {
      name: "Row Type",
      default: "",
      type: "string",
      maxLength: 20,
      selectables: [
        "Header",
        "File",
        "Information Row",
        "Single Select",
        "Multiple Select",
        "Text",
        "Yes/No",
        "Yes/No/NA",
        "Signature",
      ],
      similair: ["type", "kind", "option"],
      nullable: false,
      readOnly: false,
      helperText: "",
      error: false,
    },
    {
      name: "Select Options",
      default: "",
      type: "string",
      maxLength: 50,
      selectables: [],
      similair: [
        "options",
        "choices",
        "values",
        "answers",
        "values",
        "option",
        "choice",
        "value",
        "answer",
        "value",
      ],
      nullable: true,
      readOnly: false,
      helperText: "",
      error: false,
    },
  ];
}
